module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('em', [_vm._v("A note on the author")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Angus McAllister worked as a solicitor and university professor, and is now retired. For many years he wrote academic books and articles, as well as fiction. He is the author of "), _c('em', [_vm._v("The Krugg Syndrome")]), _vm._v(", "), _c('em', [_vm._v("The Canongate Strangler")]), _vm._v(", "), _c('em', [_vm._v("The Cyber Puppets")]), _vm._v(" and the bestselling "), _c('em', [_vm._v("Close Quarters")]), _vm._v(", and he lives in Glasgow. See www.angusmcallister.co.uk for more information.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 60
// module chunks = 0